import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FiFileText,
  FiHeart,
  FiHelpCircle,
  FiHome,
  FiLock,
  FiLogOut,
  FiUser,
} from 'react-icons/fi';
import * as S from './styles';

import logo from '../../images/logo-cuid.png';
import { useAuth } from '../../hooks/AuthContext';

const SUPPORT_URL =
  'https://api.whatsapp.com/send?phone=5511943024517&text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20com%20meu%20cadastro%20na%20plataforma%20Cuid.';

const MENU = [
  { to: '/dashboard', label: 'Início', icon: <FiHome /> },
  { to: '/documentos', label: 'Documentação', icon: <FiFileText /> },
  { to: '/perfil/editar', label: 'Editar perfil', icon: <FiUser /> },
  { to: '/perfil/editar/senha', label: 'Alterar senha', icon: <FiLock /> },
];

const Sidebar: React.FC = () => {
  const { signOut } = useAuth();
  const { pathname } = useLocation();

  return (
    <S.LSideBar>
      <Link to="/dashboard" className="logo">
        <img src={logo} alt="Logo da plataforma Cuid" />
      </Link>

      <S.Menu>
        <ul>
          {MENU.map(item => (
            <li key={item.to}>
              <Link
                to={item.to}
                className={
                  pathname.replace(/\/$/, '') === item.to ? 'active' : ''
                }
              >
                {item.icon}
                {item.label}
              </Link>
            </li>
          ))}

          <li>
            <a href={SUPPORT_URL} target="_blank" rel="noopener noreferrer">
              <FiHelpCircle />
              Suporte
            </a>
          </li>
        </ul>

        <ul>
          <li>
            <button type="button" className="danger" onClick={signOut}>
              <FiLogOut />
              Sair
            </button>
          </li>
        </ul>
      </S.Menu>

      <S.Motto>
        <FiHeart />
        <p>Juntos por um envelhecimento com mais cuidado.</p>
      </S.Motto>
    </S.LSideBar>
  );
};

export default Sidebar;
